/** Above vax program hub / wizard / form review shells (~1700) and loaders (~15000). */
export const STACKED_WARNING_MODAL_Z_INDEX = 35000;

export function stackedWarningModalLayerProps(
  zIndex: number = STACKED_WARNING_MODAL_Z_INDEX,
) {
  return {
    zIndex,
    container: typeof document !== "undefined" ? document.body : undefined,
    hideBackdrop: true,
  } as const;
}
